import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'motion/react';
import Reveal from './animations/Reveal';
import Stagger from './animations/Stagger';
import Magnetic from './animations/Magnetic';
import SectionDivider from './animations/SectionDivider';
import './BusinessSelector.css';

const BusinessSelector = () => {
  const buyerPoints = [
    'Discover verified jewellery sellers across India',
    'Browse hallmark-ready jewellery collections',
    'Compare products with transparent bullion metrics',
    'View precise gross & net weight, purity and making charges',
    'Place structured B2B wholesale orders',
    'Select flexible payment and settlement preferences',
    'Track live order fulfilment across 8 custody stages',
    'Receive verified digital order updates & invoices',
    'Manage complete procurement & transaction history',
  ];

  const sellerPoints = [
    'Create your verified digital jewellery catalogue',
    'Add products, variants, purity tiers and weight tolerances',
    'Receive structured B2B purchase orders directly',
    'Manage real-time jewellery inventory & allocations',
    'Review, negotiate and confirm wholesale orders',
    'Coordinate preparation and vault-to-vault dispatch',
    'Automate payment tracking and commercial reconciliations',
    'Reach pan-India verified wholesale jewellery buyers',
    'Track sales volume, margins and repeat buyer analytics',
  ];

  return (
    <section className="business-selector-section" id="choose-business">
      <div className="jmi-container">
        <Reveal variant="fadeUp" className="section-header-center">
          <div className="section-label">CHOOSE YOUR BUSINESS PATH</div>
          <h2 className="section-title">
            Built for Both Sides of the <span className="gold-gradient-text">Jewellery Trade</span>
          </h2>
          <p className="section-subtitle">
            Whether you are expanding retail stock or scaling manufacturing distribution,
            JMI provides dedicated workflows engineered specifically for bullion and jewellery commerce.
          </p>
        </Reveal>

        <SectionDivider style={{ marginBottom: 48 }} />

        <Stagger className="business-cards-grid" stagger={0.14}>
          {/* BUYER CARD */}
          <Stagger.Item>
            <motion.div
              className="business-card buyer-portal-card"
              whileHover={{ y: -6, transition: { duration: 0.3, ease: [0.22, 1, 0.36, 1] } }}
            >
              <div className="card-ambient-glow buyer-glow"></div>

              <div className="card-top">
                <div className="portal-badge buyer-tag">
                  <span className="portal-icon">🛍️</span>
                  <span>BUYER PORTAL</span>
                </div>
                <span className="role-sub">For Retailers, Wholesalers & Bullion Buyers</span>
              </div>

              <h3 className="card-headline">Source jewellery with greater control</h3>
              <p className="card-lead">
                Eliminate opaque pricing and fragmented procurement. Procure certified jewellery
                directly from hallmarked manufacturers with full custody tracking.
              </p>

              <div className="features-checklist">
                {buyerPoints.map((point, idx) => (
                  <div key={idx} className="check-item">
                    <span className="check-icon sapphire">✓</span>
                    <span className="check-text">{point}</span>
                  </div>
                ))}
              </div>

              <div className="card-bottom-action">
                <Magnetic strength={10} radius={160}>
                  <Link to="/buyer" className="btn btn-primary btn-lg w-full">
                    <span>Explore Buyer</span>
                    <span className="arrow-icon">→</span>
                  </Link>
                </Magnetic>
                <div className="card-action-sub">
                  No subscription fee for verified wholesale buyers
                </div>
              </div>
            </motion.div>
          </Stagger.Item>

          {/* SELLER CARD */}
          <Stagger.Item>
            <motion.div
              className="business-card seller-portal-card"
              whileHover={{ y: -6, transition: { duration: 0.3, ease: [0.22, 1, 0.36, 1] } }}
            >
              <div className="card-ambient-glow seller-glow"></div>

              <div className="card-top">
                <div className="portal-badge seller-tag">
                  <span className="portal-icon">💎</span>
                  <span>SELLER PORTAL</span>
                </div>
                <span className="role-sub">For Manufacturers, Karigars & Bullion Houses</span>
              </div>

              <h3 className="card-headline">Take your jewellery business to more buyers</h3>
              <p className="card-lead">
                Transform your physical jewellery inventory into a nationwide digital wholesale channel.
                Receive prepaid and verified orders with automated logistics.
              </p>

              <div className="features-checklist">
                {sellerPoints.map((point, idx) => (
                  <div key={idx} className="check-item">
                    <span className="check-icon gold">✓</span>
                    <span className="check-text">{point}</span>
                  </div>
                ))}
              </div>

              <div className="card-bottom-action">
                <Magnetic strength={10} radius={160}>
                  <Link to="/seller" className="btn btn-outline-gold btn-lg w-full">
                    <span>Join as Seller</span>
                    <span className="arrow-icon">→</span>
                  </Link>
                </Magnetic>
                <div className="card-action-sub">
                  Fast-track verification for GST & BIS hallmarked businesses
                </div>
              </div>
            </motion.div>
          </Stagger.Item>
        </Stagger>
      </div>
    </section>
  );
};

export default BusinessSelector;
